import type {BaseApiError, BaseApiErrorRecovery} from '@linx-security/api-specs';
import {ApiErrorType} from '@linx-security/api-specs';

import type {HTTPMethod} from './http';

export class HTTPError extends Error {
  body?: any;
  status: number;
  constructor({
    message,
    method,
    status,
    url,
    body,
  }: {
    status: number;
    message: string;
    method?: HTTPMethod | string;
    url: string | URL;
    body?: any;
  }) {
    super(`${method}: ${url} ${message}`);
    this.name = `HTTPError: ${status}`;
    this.body = body;
    this.status = status;
  }
}

export class ApiError extends HTTPError implements BaseApiError {
  type: ApiErrorType;
  recovery?: BaseApiErrorRecovery;
  msg: string;

  constructor({
    message,
    status,
    type,
    url,
    recovery,
    body,
  }: {
    status: number;
    url: string;
    method?: HTTPMethod | string;
    type: ApiErrorType;
    message: string;
    recovery?: BaseApiErrorRecovery;
    body?: any;
  }) {
    super({message, status, url, body});
    this.type = type;
    this.recovery = recovery;
    this.msg = message;
  }
}

export class InternalServerErrorResponse extends Response {
  constructor(init?: Pick<ResponseInit, 'headers'>) {
    super(null, {status: 500, statusText: `Internal Server Error`, ...init});
  }
}

export class NotFoundResponse extends Response {
  constructor(init?: Pick<ResponseInit, 'headers'>) {
    super(null, {status: 404, statusText: `Not Found`, ...init});
  }
}

export class BadRequestResponse extends Response {
  constructor(init?: Pick<ResponseInit, 'headers'>) {
    super(null, {status: 400, statusText: `Bad Request`, ...init});
  }
}

export class UnauthorizedResponse extends Response {
  constructor(init?: Pick<ResponseInit, 'headers'>) {
    super(null, {status: 401, statusText: `Unauthorized`, ...init});
  }
}

export const isErrorType = (type: any): type is ApiErrorType => {
  return typeof type === `string` && Object.values(ApiErrorType).includes(type as any);
};

export class InvalidApiResponseResponse extends Response {
  constructor(init?: Pick<ResponseInit, 'headers'>, reason?: string) {
    super(JSON.stringify({reason}), {status: 502, statusText: `Invalid API Response`, ...init});
  }
}
